export const extractText = html => html.replace(/<[^>]+>/g, '').trim();
